import { Component, OnInit, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'form-plan-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormPlanAddComponent implements OnInit {
  planForm: any = {
    title: '',
    amount: undefined,
    period: undefined,
    limit: undefined,
    description: ''
  }
  isEditForm: boolean = false;

  @Output() cancelEdit = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Input() currentPlan: any;

  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
    this.isEditForm = this.currentPlan !== undefined;
    if (this.currentPlan) {
        this.planForm = this.currentPlan
    }

    if (this.currentPlan && this.currentPlan.deletedAt !== undefined) window.history.back();
  }

  validNumber(number) {
    if (number === undefined || isNaN(number)) return false;
    return true;
  }

  canSave() {
    if (this.planForm.title === '' || this.planForm.description === '') return false;
    if (this.planForm.description.length > 100) return false;
    if (this.validNumber(this.planForm.amount) === false) return false;
    if (this.validNumber(this.planForm.period) === false) return false;
    if (this.validNumber(this.planForm.limit) === false) return false;

    return true;
  }

  savePlan() {
    this.save.emit(Object.assign({
        isNew: !this.isEditForm
    }, this.planForm))
  }

  deletePlan() {
    this.modalService.dismissAll();
    this.delete.emit();
  }

  open(content) {
    this.modalService.open(content, { centered: true });
  }
}
